<template>
  <div id="contentBack" class="content-back">
    <router-link v-bind:to="btnRoute" class="nunito"> <i class="fa fa-arrow-left" aria-hidden="true"></i> Voltar</router-link>
  </div>
</template>

<script>
  export default {
    name:'button-back',
    props:['btnRoute']
  }
</script>



// WEBPACK FOOTER //
// src/vue/views/components/buttonBack.vue